import { Navigate } from 'react-router-dom';
import { urlNavigate } from '../helper/utils/navigation';

export default function ProtectedRoute({ children }) {
    // Read from localStorage dynamically on each render
    const isVerifiedWaiver = (localStorage.getItem('isVerifiedWaiver') || 'false') === 'true';

    if (!isVerifiedWaiver) {
        return <Navigate to={`${urlNavigate('online-sales', 'home?isOpenLogin=true&callback=/dashboard/membership')}`} replace />;
    }

    return children;
}
